import axios from "axios";

let ins = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 6000,
});

ins.interceptors.request.use((config) => {
  return config;
});
ins.interceptors.response.use((res) => {
  return res;
});

export default ins;
